
export default function Hero() {
  const scrollToServices = () => {
    const servicesSection = document.getElementById('services');
    if (servicesSection) {
      servicesSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-32 md:pt-20">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://ik.imagekit.io/pianomoverslondon/tr:w-1200,h-800,c-at_max,q-85,f-webp/Piano%20Movers%20Gallery%20London%20Jobs/Piano_Movers_London_Pictures_from_job%20(1).jpeg"
          srcSet="https://ik.imagekit.io/pianomoverslondon/tr:w-800,h-533,c-at_max,q-85,f-webp/Piano%20Movers%20Gallery%20London%20Jobs/Piano_Movers_London_Pictures_from_job%20(1).jpeg 800w, https://ik.imagekit.io/pianomoverslondon/tr:w-1200,h-800,c-at_max,q-85,f-webp/Piano%20Movers%20Gallery%20London%20Jobs/Piano_Movers_London_Pictures_from_job%20(1).jpeg 1200w"
          sizes="100vw"
          alt="Professional piano movers London — specialist team moving upright piano"
          title="London Piano Moving Services - Professional Transport"
          width="1200"
          height="800"
          className="w-full h-full object-cover object-top"
          fetchpriority="high"
          decoding="async"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>

      <div className="relative z-10 max-w-5xl mx-auto text-center w-full px-6 py-8">
        <h1 className="text-3xl sm:text-4xl md:text-7xl font-serif font-bold mb-4 md:mb-6 text-[#f5f5f0] leading-tight">
          London&apos;s Trusted Piano Movers
        </h1>
        <p className="text-base sm:text-lg md:text-2xl mb-8 md:mb-10 text-[#d4d4ce] max-w-3xl mx-auto leading-relaxed">
          Specialist piano moving service across London, Essex, Kent, Surrey and Hertfordshire. Fully insured with £5M Goods in Transit cover. Free fixed-price quotes — no hidden fees.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12 md:mb-16">
          <a
            href="https://www.pianomoveteam.co.uk/order.html"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Get a free piano moving quote from Piano Movers UK"
            className="bg-[#c9a84c] text-[#0e0d0b] px-8 py-4 rounded-lg font-semibold text-lg hover:bg-[#d4b55f] transition-colors whitespace-nowrap cursor-pointer"
          >
            Get Free Quote
          </a>
          <button
            onClick={scrollToServices}
            aria-label="Scroll down to view our piano moving services"
            className="border-2 border-[#c9a84c] text-[#c9a84c] px-8 py-4 rounded-lg font-semibold text-lg hover:bg-[#c9a84c] hover:text-[#0e0d0b] transition-colors whitespace-nowrap cursor-pointer"
          >
            Our Services
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 max-w-4xl mx-auto">
          <div className="text-center">
            <div className="text-3xl md:text-4xl font-bold text-[#c9a84c] mb-2">18+</div>
            <div className="text-[#d4d4ce] text-sm">Years Experience</div>
          </div>
          <div className="text-center">
            <div className="text-3xl md:text-4xl font-bold text-[#c9a84c] mb-2">30,000+</div>
            <div className="text-[#d4d4ce] text-sm">Pianos Moved</div>
          </div>
          <div className="text-center">
            <div className="text-3xl md:text-4xl font-bold text-[#c9a84c] mb-2">£5M</div>
            <div className="text-[#d4d4ce] text-sm">Insurance Cover</div>
          </div>
        </div>
      </div>
    </section>
  );
}
